export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://ysocial.ru/api';
export const HOST_BASE_URL = 'https://ysocial.ru'
